import BottomAction from './BottomAction';
import RightAction from './RightAction';

export default {
  RightAction,
  BottomAction
};
